import { CircularProgressWrapper } from 'globalStyles';

import { CircularProgress as MaterialCircularProgress } from '@mui/material';

/**
 * Block-level loading spinner: MUI's CircularProgress centered inside the
 * shared `CircularProgressWrapper` (full width, height `calc(100% - 200px)`).
 * Takes no props — use it as a whole-section loading state; for an inline or
 * custom-sized spinner use MUI's CircularProgress directly.
 */
const CircularProgress = () => (
  <CircularProgressWrapper>
    <MaterialCircularProgress />
  </CircularProgressWrapper>
);

export default CircularProgress;
